type MapMicrocopyHeaders = <T>(namedMC: T, microcopies: object) => T;

export const mapMicrocopyHeaders: MapMicrocopyHeaders = <T>(namedMC: T, microcopies: object) => {
    const MCKeyValues = Object.entries(namedMC);
    const mapped = [...MCKeyValues].map(([k, v]) => {
        return { [k]: microcopies[v] || "" };
    });
    return Object.assign({}, ...mapped);
};
